import { withProps } from 'recompose';

export default logId => withProps(props => {
  console.log(logId, props)
})
